function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Image } from "expo-image";
import { createContext, useEffect, useMemo, useRef, useState } from "react";
import { AppState } from "react-native";
import NotConnected from "../assets/notconnected.svg";
import { Button } from "./Button";
import { Icon } from "./Icon";
import { MandatoryModal } from "./Modal";
import { Text } from "./Text";
import { View } from "./View";
import { addBreadcrumb } from "../lib/log";
// import { resumableUploadManager } from '../lib/resumableUploadManager';
import NetInfo, { fetchIsConnected } from "../lib/NetInfo";
import { Shadow } from "../styles";
var InternetConnectivityContext = /*#__PURE__*/ createContext({
    isInternetReachable: null
});
/**
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-87}
 */ export function InternetConnectivityProvider(param) {
    var children = param.children, forceOffline = param.forceOffline, onReconnect = param.onReconnect;
    var _useState = _sliced_to_array(useState(null), 2), isInternetReachable = _useState[0], setIsInternetReachable = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), showModal = _useState1[0], setShowModal = _useState1[1];
    var forceOfflineRef = useRef(forceOffline);
    forceOfflineRef.current = forceOffline;
    var onReconnectRef = useRef(onReconnect);
    onReconnectRef.current = onReconnect;
    useEffect(function() {
        var isReachable = function isReachable() {
            if (!forceOfflineRef.current) {
                setShowModal(false);
                setIsInternetReachable(true);
                onReconnectRef.current();
            }
        };
        var tryNetworkFetch = function tryNetworkFetch() {
            // fetchIsConnected never rejects so it is safe to use void
            void fetchIsConnected().then(function(isConnected) {
                if (isConnected) {
                    isReachable();
                } else {
                    setShowModal(true);
                    setIsInternetReachable(false);
                }
            });
        };
        var notifyUserTimeout;
        var remove = NetInfo.addEventListener(function(state) {
            clearTimeout(notifyUserTimeout);
            addBreadcrumb({
                category: 'net-info',
                data: {
                    state: state
                },
                level: 'debug'
            });
            if (state.isInternetReachable === false) {
                notifyUserTimeout = setTimeout(function() {
                    tryNetworkFetch();
                // This timeout helps prevent the offline state from flapping in a way that's visible to the user
                }, 10000);
            } else if (state.isInternetReachable === true) {
                isReachable();
            }
        });
        var onAppState = function(status) {
            if (status === 'active') {
                tryNetworkFetch();
            }
        };
        var appStateListener = AppState.addEventListener('change', onAppState);
        return function() {
            appStateListener.remove();
            clearTimeout(notifyUserTimeout);
            remove();
        };
    }, []);
    useEffect(function() {
        if (forceOffline) {
            setShowModal(true);
            setIsInternetReachable(false);
        } else {
            setShowModal(false);
            setIsInternetReachable(true);
        }
    }, [
        forceOffline
    ]);
    var value = useMemo(function() {
        return {
            isInternetReachable: isInternetReachable
        };
    }, [
        isInternetReachable
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(InternetConnectivityContext.Provider, {
                value: value,
                children: children
            }),
            isInternetReachable || isInternetReachable === null ? null : showModal ? /*#__PURE__*/ _jsx(MandatoryModal, {
                visible: true,
                children: /*#__PURE__*/ _jsxs(View, {
                    spacing: 16,
                    style: {
                        alignItems: 'center'
                    },
                    children: [
                        /*#__PURE__*/ _jsx(Image, {
                            source: NotConnected,
                            style: {
                                width: 48,
                                height: 48
                            }
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            text: "You're offline",
                            weight: "bold",
                            size: 21
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            text: "Try reconnecting your wifi or data.\n\nYou'll be able to access things you've already done, but not do new things while you're offline.",
                            textAlign: "center"
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            text: "OK",
                            variant: "solid",
                            onPress: function() {
                                return setShowModal(false);
                            },
                            alignSelf: "center",
                            testID: "InternetConnectivityProvider_acknowledgeButton"
                        })
                    ]
                })
            }) : /*#__PURE__*/ _jsx(View, {
                pointerEvents: "none",
                style: {
                    justifyContent: 'center',
                    alignItems: 'center',
                    position: 'absolute',
                    top: 140,
                    width: '100%'
                },
                children: /*#__PURE__*/ _jsxs(View, {
                    testID: "InternetConnectivityProvider_banner",
                    style: [
                        {
                            backgroundColor: '#932a2a',
                            borderRadius: 5,
                            paddingHorizontal: 10,
                            paddingVertical: 5
                        },
                        Shadow.low
                    ],
                    row: true,
                    spacing: 8,
                    children: [
                        /*#__PURE__*/ _jsx(Icon, {
                            name: "cloud-offline",
                            color: "white"
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            text: "Currently offline",
                            color: "white",
                            weight: "semibold"
                        })
                    ]
                })
            })
        ]
    });
}
